<template>
	<PublicPage current="/help-center" eyebrow="CONTACT US" :title="['Let\'s talk.', 'We\'re listening.']" lead="Questions about a payment, your account, or working with Paydeck? Reach our team by email.">
		<PdContactCard :guides="guides" />
		<div class="contact-links">
			<PdArrowLink href="/frequently-asked-questions" underline>Read the FAQs</PdArrowLink>
			<PdArrowLink href="/settlement-guide" underline>Fraud reporting guidance</PdArrowLink>
			<PdArrowLink href="/refund-policy" underline>Refund policy</PdArrowLink>
		</div>
	</PublicPage>
</template>

<script setup>
import PdContactCard from "@paydeck-ui/components/marketing/PdContactCard.vue";
import PdArrowLink from "@paydeck-ui/components/PdArrowLink.vue";
import PublicPage from "@/components/site/PublicPage.vue";

const guides = [
	{ title: "Help us find your case", body: "If your question is about a payment, include your transaction ID, the date, amount and a short explanation. For an account issue, write from the email address linked to your Paydeck account." },
	{ title: "Keep sensitive details private", body: "Never send your card PIN, CVV, OTP or password by email. If you suspect unauthorised activity, contact your bank immediately and read our fraud reporting guidance." }
];
</script>
